import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async oauth(url: string) {
    return await this.call(url, {
      method: 'post',
    })
  }

  async login(credentials: any): Promise<any> {
    return await this.call('/auth/login', {
      method: 'post',
      body: credentials,
    })
  }

  async logout(): Promise<any> {
    return await this.call('/auth/logout', {
      method: 'post',
    })
  }

  async register(credentials: any): Promise<any> {
    return await this.call('/auth/register', {
      method: 'post',
      body: credentials,
    })
  }

  async twoFactorChallenge(data: any): Promise<any> {
    return await this.call('/auth/two-factor-challenge', {
      method: 'post',
      body: data,
    })
  }

  async passwordForgot(email: string): Promise<any> {
    return await this.call('/auth/forgot-password', {
      method: 'post',
      body: { email },
    })
  }

  async passwordReset(credentials: any): Promise<{ status: string }> {
    return await this.call('/auth/reset-password', {
      method: 'post',
      body: credentials,
    })
  }

  async emailSendVerification(): Promise<any> {
    return await this.call('/auth/email/verification-notification', {
      method: 'post',
    })
  }

  async leaveImpersonation() {
    return await this.call('/auth/impersonation', {
      method: 'get',
    })
  }
}
